import classNames from 'classnames'
import React from 'react'
import { Card, Container, Row } from 'react-bootstrap'
import './CommonCard.scss'

interface CommonCardProps {
  onCardClick: () => void
  header: React.ReactNode
  description: React.ReactNode
  state: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

export const CommonCard: React.FC<CommonCardProps> = ({ onCardClick, header, description, state, footer, className }) => {
  return (
    <Card className={classNames('common-card rounded-3', className)} onClick={onCardClick}>
      <Card.Body className='p-4'>
        <Container className='common-card__body-wrapper p-0'>
          <div className='rounded common-card__header justify-content-between'>{header}</div>

          <Row>{description}</Row>

          {state}

          {footer ? (
            <Row className='common-card__footer'>
              <Row className='common-card__footer'>{footer}</Row>
            </Row>
          ) : null}
        </Container>
      </Card.Body>
    </Card>
  )
}
